import ScrollReveal from "@/components/feature/ScrollReveal";

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-gray-50 dark:bg-dark-card">
      <div className="px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <ScrollReveal>
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/47b2e0f1-f782-46fd-9795-faa524ec7a75/6baf50e9-3d04-45c2-9c96-de291399f86a_image-3-1.png?v=f07b3b429b89e9ef7ec28941e7818d1d"
                alt="Presuni team"
                className="w-full h-[300px] md:h-[420px] object-cover rounded-2xl"
                loading="lazy"
              />
            </div>
          </ScrollReveal>

          <div>
            <ScrollReveal>
              <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
                Why Presuni
              </span>
              <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                Built for Enterprise. Trusted Since 2006.
              </h2>
              <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 leading-relaxed mb-6">
                Presuni has spent nearly two decades helping organisations navigate complex technology landscapes. We combine deep security expertise with modern software engineering to deliver solutions that actually work.
              </p>
            </ScrollReveal>

            <div className="space-y-4">
              {[
                { label: "Years of Experience", value: "18+" },
                { label: "Enterprise Clients", value: "120+" },
                { label: "Certified Engineers", value: "45+" },
              ].map((stat, i) => (
                <ScrollReveal key={stat.label} delay={i + 1}>
                  <div className="flex items-center gap-4 p-4 rounded-xl bg-white dark:bg-dark-bg border border-gray-100 dark:border-dark-border">
                    <div className="text-2xl md:text-3xl font-extrabold text-brand-500">
                      {stat.value}
                    </div>
                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {stat.label}
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}